import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: variables.white,
      justifyContent: 'space-between',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 598,
      padding: '50px 60px',
      height: 557,
      margin: `${theme.spacing(0)} auto`,

      '@media (max-width: 600px)': {
        width: '100%',
        display: 'block',
      },
    },
    errorContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 470,
      padding: '50px 60px',
      height: 398,
      margin: `${theme.spacing(0)} auto`,
      textAlign: 'center',

      '@media (max-width: 600px)': {
        width: 'unset',
      },
    },
    margin: {
      marginTop: 40,
      marginBottom: 40,
    },
    loginBtn: {
      borderRadius: 4,
      height: 46,

      '&:hover': {
        backgroundColor: variables.cobaltBlue,
        color: variables.white,
      },
    },
    header: {
      fontWeight: 700,
      fontSize: 28,
      textAlign: 'center',
      color: variables.black,
    },
    card: {
      boxShadow: 'none',
      width: 504,

      '@media (max-width: 600px)': {
        width: 'unset',
      },
    },
    required: {
      color: variables.red,
    },
    input: {
      '& .MuiOutlinedInput-input': {
        fontSize: 14,
        color: variables.policeBlue,
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 4,
        height: 40,
      },
    },
    icon: {
      color: variables.policeBlue,
    },
    padding: {
      paddingTop: 30,
    },
    label: {
      fontSize: 14,
      fontWeight: 500,
      color: variables.policeBlue,
    },
    cardActions: {
      marginBottom: 40,
      justifyContent: 'center',
    },
    errorMessage: {
      margin: '25px 0',
      padding: '8px 18px 9px 12px',
      borderRadius: 5,
      backgroundColor: variables.americanPink,
      color: variables.white,
      alignContent: 'center',
      display: 'flex',
    },
    ddl: {
      boxShadow: 'none',
      padding: 5,
      borderRadius: '15px !important',
      margin: 0,
      border: '1px solid rgba(0, 0, 0, 0.23) !important',
      ' &:hover': {
        border: '1px solid black',
      },
    },
    formControlLabel: {
      margin: '30px 0 0 0',
      fontWeight: 500,
      color: variables.black,
    },
    errorCard: {
      boxShadow: 'none',
    },
    errorCardActions: {
      marginTop: 30,
      marginBottom: 40,
      justifyContent: 'center',
    },
    forgotPassword: {
      paddingTop: 30,
      textAlign: 'center',
    },
  }),
);
